import { render, staticRenderFns } from "./DepartmentPageTable.vue?vue&type=template&id=4c7ff5de&scoped=true&"
import script from "./DepartmentPageTable.vue?vue&type=script&lang=js&"
export * from "./DepartmentPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ff5de",
  null
  
)

export default component.exports